import { Locale } from 'languages';

export const getLocalizedPath = (locale: string, path: string): string => {
  if (!locale || locale === Locale.ENGLISH) {
    return path || '/';
  }

  const normalizedPath = path ? path.replace(/^\//, '') : '';

  return normalizedPath ? `/${locale}/${normalizedPath}` : `/${locale}`;
};

export const DEFAULT_PAGE_TITLE = 'Luckyelfcasino';
